const ffcURLParms = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };
 
  if (ffcURLParms.search) {

    $('.faq--container').remove()

    $(".search-value").html('"' + ffcURLParms.search + '"')

    const accordions = $(".accordion-item").filter(function(idx) {
      let valid = ffcURLParms.search.split(' ').every(term => this.textContent.includes(term))
      return valid
    });

    accordions.each(function() {
        $(this).addClass('active')
    })

    $('#faq-count').html(accordions.length)

    accordions.length > 1 ? $('#faq-plural').html('RESULTS') : $('#faq-plural').html('RESULT')
    $('.search-module').removeClass('hide')

  } else {
    $('.search-module').remove()

    $(".accordion-item").each(function() {
        $(this).addClass('active')
    })
    $(".accordion-item").each(function(index) {
      if (index <= 2) {
        $(this).removeClass('hide')
      }
    })
    $('.faq--container').removeClass('hide')

    if (ffcURLParms.topic) {
      $('.accordion-item:not([data-faq-item-topic="' + ffcURLParms.topic + '"])').remove()
      $('[data-faq-topic]').html(ffcURLParms.topic)
    }
  }

  $('[data-faq-count]').html($('.accordion-item.active').length)


  if (ffcURLParms.question) {

    
      let question = handleize(ffcURLParms.question)
    

    $('[data-faq-item-title="' + question  +'"]').addClass('viewed-question')
    $('[data-faq-item-title="' + question  +'"]').addClass('open')
    $('[data-faq-item-title="' + question  +'"] [data-toggle-elem]').addClass('open')
  }